import React from 'react';
import ReactDOM from 'react-dom';

import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';

import PrimarySearchAppBar from './components/common/AppHeader'
import AdminHome from './components/admin/AdminHome'
import AdminMenu from './components/admin/AdminMenuRoutes'
import ResidentSection from './components/residents/ResidentSection'
import FacilitySection from './components/facility/FacilitySection'
import HomePage from './components/pages/HomePage'
import AboutPage from './components/pages/AboutPage'
import ContactPage from './components/pages/ContactPage'
import ResponsiveDrawer from './components/UserAccount/MyAccount'
import AlertsTable from './components/alerts/AlertsTable.js';
import logo from './logo.svg';
import './App.css';

import {BrowserRouter as Router , Switch, Route, Link, Redirect} from 'react-router-dom';


const styles = {
  root: {
    margin: 20,
   
  },
  gridItem: {
    backgroundColor: "blue",
    color: "white",
    borderStyle: "solid"
  },
  footer:{
    zIndex: 200,
    backgroundColor:"#dde6ec",
    color: "#99a6bb",
    height: 40,
    position: 'fixed',
    bottom:0,
    width: '100%',
    '& p':{
      margin: 'auto',
      padding: 10,
    }
  },
  route_container:{
    position: 'relative',
    zIndex: 100,
  }
};

const App = props => {
  const { classes } = props;
  return (
    <div className="App">
      <Router>
      <header className="App-header">
        <PrimarySearchAppBar />

      </header>
      <div className={classes.route_container}>
        <Switch>
          <Redirect exact from="/admin" to="/admin/residents" />
          <Redirect exact from="/residents" to="/residents/all" />
          <Route path="/" exact component={HomePage} />
          <Route path="/about" exact component={AboutPage} />
          <Route path="/contact" exact component={ContactPage} />
          <Route exact path="/residents/:page?/:subpage?"  render={props => <ResidentSection {...props} />} />
          <Route path="/facility"  component={FacilitySection} />
          <Route exact path="/admin/:page?/:subpage?" render={props => <AdminMenu {...props} />} />
          <Route path="/myaccount"  component={ResponsiveDrawer} />
          <Route path="/alerts"  component={AlertsTable} />
          
          
        </Switch>
        </div>
    </Router>
{/*
        <Grid container>
          <Grid item xs={3} className={classes.gridItem}>
            ONE
          </Grid>
          <Grid item xs={3} className={classes.gridItem}>
            TWO
          </Grid>
          <Grid item xs={3} className={classes.gridItem}>
            THREE
          </Grid>
          <Grid item xs={3} className={classes.gridItem}>
            FOUR
          </Grid>
        </Grid>
*/}
  <div className={classes.footer}>
    <p>Copyright Spectator Health 2020
      </p>
    </div>
    </div>
  );
}

export default withStyles(styles)(App);
/*
<AdminHome name='josh' />
      <Button variant="contained" color="primary">
      Hello World
    </Button>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
*/